import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "divide-y divide-gray-200 rounded-lg bg-white shadow" }
const _hoisted_2 = { class: "px-4 py-5 sm:px-6 flex items-center gap-x-4" }
const _hoisted_3 = {
  type: "button",
  class: "inline-flex items-center gap-x-2 rounded-md bg-white px-2.5 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
}
const _hoisted_4 = { class: "h-5 w-5 shrink-0 text-gray-900 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold leading-6 text-gray-900" }, " Edit Student "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Set up an account for a Student so they can log in ")
], -1)
const _hoisted_6 = { class: "px-4 py-5 sm:px-6" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-y-2.5 gap-x-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "formkit-label text-slate-700 text-sm font-medium"
}, [
  /*#__PURE__*/_createTextVNode(" First Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-base text-red-500" }, "*")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "formkit-label text-slate-700 text-sm font-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Surname"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-base text-red-500" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "formkit-label text-slate-700 text-sm font-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Email (Username)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-base text-red-500" }, "*")
], -1)
const _hoisted_11 = {
  for: "password",
  class: "formkit-label text-slate-700 text-sm font-medium"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-red-500" }, "*", -1)
const _hoisted_13 = {
  key: 0,
  class: "ml-2 text-xs text-gray-500"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "grade",
  class: "formkit-label text-slate-700 text-sm font-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Grade"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-base text-red-500" }, "*")
], -1)
const _hoisted_15 = { class: "col-span-2 flex gap-x-4" }
const _hoisted_16 = { class: "col-span-2 mt-4 pt-4 border-t border-gray-200" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_18 = {
  for: "mathsAssessmentLevel",
  class: "formkit-label text-slate-700 text-sm font-medium"
}
const _hoisted_19 = { class: "flex gap-x-2 items-center" }
const _hoisted_20 = {
  for: "englishAssessmentLevel",
  class: "formkit-label text-slate-700 text-sm font-medium"
}
const _hoisted_21 = { class: "flex gap-x-2 items-center" }
const _hoisted_22 = {
  key: 0,
  class: "mt-6 border-l-4 border-yellow-400 bg-yellow-50 p-4"
}
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "shrink-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-700" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Class selection required:"),
    /*#__PURE__*/_createTextVNode(" You have changed the grade. Please select at least one new class to proceed. ")
  ])
], -1)
const _hoisted_26 = {
  key: 1,
  class: "mt-6 border-l-4 border-yellow-400 bg-yellow-50 p-4"
}
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "shrink-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-700" }, [
    /*#__PURE__*/_createElementVNode("span", {
      href: "#",
      class: "font-medium text-yellow-700"
    }, "Warning: "),
    /*#__PURE__*/_createTextVNode(" editing a Student’s Assessment Level typically gives a fresh start, with progress appearing to reset ")
  ])
], -1)
const _hoisted_30 = { class: "px-4 py-4 sm:px-6 flex items-center gap-x-2 justify-end" }
const _hoisted_31 = { class: "w-full flex items-center gap-x-2" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_33 = {
  key: 1,
  class: "font-semibold"
}

import { ref, computed, watch, onMounted, onBeforeMount, nextTick } from 'vue';
import { useLearnerStore } from '@/stores/learnerStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { useUserStore } from '@/stores/userStore';
import { submitForm } from '@formkit/vue';
import { FormKitNode } from '@formkit/core';
import { showToast } from '@/utils/toastUtils';
import { CheckCircleIcon, ExclamationTriangleIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/outline';

interface EditLearnerData {
  email: string;
  grade: number | null;
  password: string;
  lastName: string;
  firstName: string;
  mathsClass: string;
  englishClass: string;
  studentNumber: string;
  learningMode: string;
  preferredLang: string;
  repeatingGrade: boolean;
  mathsAssessmentLevel: string;
  englishAssessmentLevel: string;
}

interface Props {
  studentId: string;
  decryptedPassword?: string;
}

const disableAssessmentFields = false;

// Store original email for validation
const UK_PILOT_SCHOOL_GROUP_ID = '68d14131a93501d6d0f1c4f2';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditLearnerModalComponent',
  props: {
    studentId: {},
    decryptedPassword: {}
  },
  emits: ["closeModal", "password-updated", "password-fetched"],
  setup(__props: any, { emit }) {

const props = __props;




// Stores
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const userStore = useUserStore();

// Form data
const editLearner = ref<EditLearnerData>({
  grade: null,
  email: "",
  password: "",
  lastName: "",
  firstName: "",
  mathsClass: "",
  englishClass: "",
  studentNumber: "",
  mathsAssessmentLevel: "",
  englishAssessmentLevel: "",
  repeatingGrade: false,
  learningMode: "default",
  preferredLang: "default"
});

const isClassDataLoaded = ref(false);
// const disableAssessmentFields = computed(() => userStore.isClassGroupAdmin);
const originalEmail = ref("");

// Store original values for comparison
const originalValues = ref<any>({});
const isPasswordLoading = ref(false);

// Assessment validation
const isValidMathsAssessment = ref(true);
const isValidEnglishAssessment = ref(true);

// Current assessment states
const currentMathsAssessment = ref<any>(null);
const currentEnglishAssessment = ref<any>(null);

// Load student data on mount
onBeforeMount(async () => {
  const student = learnerStore.getLearnerById(props.studentId);
  if (student) {
    // Find assessment states
    currentMathsAssessment.value = student.assessmentStates?.find(
      state => state.subject === 'MATHS'
    );
    currentEnglishAssessment.value = student.assessmentStates?.find(
      state => state.subject === 'ENGLISH'
    );

    // Get current class assignments first
    const mathsClassId = student.classes.find(c => c.subject.code === 'MATHS')?._id || "";
    const englishClassId = student.classes.find(c => c.subject.code === 'ENGLISH')?._id || "";

    // Populate form with existing data
    editLearner.value = {
      email: student.email,
      password: "",
      lastName: student.lastName,
      firstName: student.firstName,
      studentNumber: student.studentNumber || "",
      grade: student.grade,
      mathsClass: "",
      englishClass: "",
      mathsAssessmentLevel: currentMathsAssessment.value?.type || "",
      englishAssessmentLevel: currentEnglishAssessment.value?.type || "",
      repeatingGrade: student.repeatingGrade || false,
      learningMode: student.learningMode || "default",
      preferredLang: student.preferredLang || "default"
    };

    // Wait for Vue to process the grade change and update computed properties
    await nextTick();

    // Now, safely set the class values
    editLearner.value.mathsClass = mathsClassId;
    editLearner.value.englishClass = englishClassId;

    isClassDataLoaded.value = true;

    // Store original values for comparison
    originalValues.value = JSON.parse(JSON.stringify(editLearner.value));
    originalEmail.value = student.email;

    // --- NEW PASSWORD LOGIC ---
    if (props.decryptedPassword) {
      // If password was passed as a prop, use it directly
      editLearner.value.password = props.decryptedPassword;
      originalValues.value.password = props.decryptedPassword;
    } else {
      // Otherwise, decrypt it on modal load
      isPasswordLoading.value = true;
      try {
        const password = await learnerStore.fetchDecryptedPassword(props.studentId);
        if (password) {
          editLearner.value.password = password;
          originalValues.value.password = password;

          // emit the fetched password
          emit('password-fetched', password);
        }
      } catch (error) {
        console.error("Failed to decrypt password on modal load:", error);
        showToast({
          text: 'Could not load student password.',
          type: 'error',
          icon: CheckCircleIcon,
        });
      } finally {
        isPasswordLoading.value = false;
      }
    }


    // Set current class assignments
    // student.classes?.forEach(cls => {
    //   if (cls.subject.code === 'MATHS') {
    //     editLearner.value.mathsClass = cls._id;
    //     originalValues.value.mathsClass = cls._id;
    //   } else if (cls.subject.code === 'ENGLISH') {
    //     editLearner.value.englishClass = cls._id;
    //     originalValues.value.englishClass = cls._id; 
    //   }
    // });

    // console.log("DATA: ", editLearner.value);
    // console.log("DATA: ", originalValues.value);
  }
});

// Add these computed properties to determine the actual default values
const mathsClassGroup = computed(() => {
  if (!editLearner.value.mathsClass) return null;
  const structure = schoolStore.currentSchoolStructure;
  return structure?.classGroups?.find(cg => cg._id === editLearner.value.mathsClass);
});

const defaultPreferredLang = computed(() => {
  // First check maths class group
  const classLang = mathsClassGroup.value?.preferredLanguage
  if (classLang) return classLang
  // Otherwise use the school’s preferredLang
  return schoolStore.currentSchoolStructure?.preferredLang ?? 'en-ZA'
});

const defaultLearningMode = computed(() => {
  // First check maths class group
  if (mathsClassGroup.value?.learningMode) {
    return mathsClassGroup.value.learningMode;
  }
  // Fallback to school default
  return schoolStore.currentSchoolStructure?.learningMode || 'guided';
});

const defaultLangSource = computed(() => {
  return mathsClassGroup.value?.preferredLanguage ? 'Class' : 'School';
});

const defaultLearningModeSource = computed(() => {
  return mathsClassGroup.value?.learningMode ? 'Class' : 'School';
});

// Add these computed properties after the existing ones
const languageOptions = computed(() => {
  const defaultOption = {
    name: `${defaultLangSource.value} Default (${defaultPreferredLang.value})`,
    id: 'default'
  };
  const localeOptions = (schoolStore.locales || []).map(lang => ({
    name: lang.name,
    id: lang.code
  }));
  return [defaultOption, ...localeOptions];
});

const learningModeOptions = computed(() => {
  const defaultOption = {
    name: `${defaultLearningModeSource.value} Default (${defaultLearningMode.value})`,
    id: 'default'
  };
  const modeOptions = schoolStore.getLearningModes.map(mode => ({
    name: mode.label,
    id: mode.value
  }));
  return [defaultOption, ...modeOptions];
});

// Check if subjects are available
const isMathsAvailable = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.subjectsAvailable) return false;
  return structure.subjectsAvailable.some(subject => subject.code === 'MATHS');
});

const isEnglishAvailable = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.subjectsAvailable) return false;
  return structure.subjectsAvailable.some(subject => subject.code === 'ENGLISH');
});

const schoolIsV2Only = computed(() => {
  const subjects = schoolStore.currentSchoolStructure?.subjectsAvailable || [];
  const hasEnglish = subjects.some(subject => subject.code === 'ENGLISH' || subject.name?.toLowerCase() === 'english');
  const hasMaths = subjects.some(subject => subject.code === 'MATHS' || subject.name?.toLowerCase() === 'maths');
  return schoolStore.lingoMode === 'v2' && hasEnglish && !hasMaths;
});

// Check if school has only one subject (for simplified labels)
const isSingleSubjectSchool = computed(() => {
  return (isMathsAvailable.value && !isEnglishAvailable.value) ||
         (!isMathsAvailable.value && isEnglishAvailable.value);
});

// Dynamic labels based on whether school has single or multiple subjects
const mathsClassLabel = computed(() => isSingleSubjectSchool.value ? 'Class' : 'Maths Class');
const englishClassLabel = computed(() => isSingleSubjectSchool.value ? 'Class' : 'English Class');
const mathsClassPlaceholder = computed(() => isSingleSubjectSchool.value ? 'Select Class' : 'Select Maths Class');
const englishClassPlaceholder = computed(() => isSingleSubjectSchool.value ? 'Select Class' : 'Select English Class');

// Get the subject IDs
const mathsSubjectId = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.subjectsAvailable) return null;
  const mathsSubject = structure.subjectsAvailable.find(subject => subject.code === 'MATHS');
  return mathsSubject?._id || null;
});

const englishSubjectId = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.subjectsAvailable) return null;
  const englishSubject = structure.subjectsAvailable.find(subject => subject.code === 'ENGLISH');
  return englishSubject?._id || null;
});

// Grade options
const gradeOptions = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.gradeLevels) return [];

  return structure.gradeLevels.map(grade => ({
    name: `Grade ${grade}`,
    id: grade
  }));
});

// Maths class options filtered by grade
const mathsClassOptionsByGrade = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.classGroups || !mathsSubjectId.value) return [];

  const mathsClasses = structure.classGroups
    .filter(classGroup =>
      classGroup.subject === mathsSubjectId.value &&
      classGroup.gradeLevel === editLearner.value.grade
    )
    .map(classGroup => ({
      name: `${classGroup.name} (Grade ${classGroup.gradeLevel})`,
      id: classGroup._id
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const emptyOptionLabel = isSingleSubjectSchool.value ? 'None Assigned' : 'None Assigned';
  return [{ name: emptyOptionLabel, id: '' }, ...mathsClasses];
});

// English class options filtered by grade
const englishClassOptionsByGrade = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure?.classGroups || !englishSubjectId.value) return [];

  const englishClasses = structure.classGroups
    .filter(classGroup =>
      classGroup.subject === englishSubjectId.value &&
      classGroup.gradeLevel === editLearner.value.grade
    )
    .map(classGroup => ({
      name: `${classGroup.name} (Grade ${classGroup.gradeLevel})`,
      id: classGroup._id
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const emptyOptionLabel = isSingleSubjectSchool.value ? 'None Assigned' : 'None Assigned';
  return [{ name: emptyOptionLabel, id: '' }, ...englishClasses];
});

const assessmentLevelToChange = computed(() => {
  const mathsToChange = (currentMathsAssessment.value &&
    editLearner.value.mathsAssessmentLevel !== originalValues.value.mathsAssessmentLevel)
  const englishToChange = (currentEnglishAssessment.value &&
    editLearner.value.englishAssessmentLevel !== originalValues.value.englishAssessmentLevel)
  return mathsToChange || englishToChange;
});

const showGradeChangeWarning = computed(() => {// 1. Check if the grade has been changed from its original value
  const gradeChanged = editLearner.value.grade !== originalValues.value.grade;
  if (!gradeChanged) {
    return false;
  }

  const subjectsAreAvailable = isMathsAvailable.value || isEnglishAvailable.value;
  const newClassWasSelected = (isMathsAvailable.value && editLearner.value.mathsClass) || (isEnglishAvailable.value && editLearner.value.englishClass);

  return subjectsAreAvailable && !newClassWasSelected;
});

// Reset class selections when grade changes
watch(() => editLearner.value.grade, (newGrade, oldGrade) => {
  if (newGrade !== oldGrade) {
    editLearner.value.mathsClass = '';
    editLearner.value.englishClass = '';
  }
});

watch(() => editLearner.value.mathsClass, (newClassId) => {
  // If a new class is chosen and no assessment existed before
  if (newClassId && !currentMathsAssessment.value) {
    const defaultType = getAssessmentTypeForGrade('MATHS', editLearner.value.grade as number);
    editLearner.value.mathsAssessmentLevel = defaultType;
  }
});

watch(() => editLearner.value.englishClass, (newClassId) => {
  // If a new class is chosen and no assessment existed before
  if (newClassId && !currentEnglishAssessment.value) {
    const defaultType = getAssessmentTypeForGrade('ENGLISH', editLearner.value.grade as number);
    editLearner.value.englishAssessmentLevel = defaultType;
  }
});

// SPV2 is only available for en-ZA / af-ZA schools and classes; the UK Pilot
// Group has no V2 locale yet so it's also excluded.
const SPV2_SUPPORTED_LOCALES = ['en', 'en-ZA', 'af-ZA'];

const hideSeniorPrimaryV2 = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  const schoolLocale = structure?.preferredLang;
  if (schoolLocale && !SPV2_SUPPORTED_LOCALES.includes(schoolLocale)) return true;
  if (structure?.schoolGroup === UK_PILOT_SCHOOL_GROUP_ID) return true;
  return false;
});

// Assessment level options
const mathsAssessmentOptions = computed(() => {
  const options = [
    { id: 'MATHS_JUNIOR_PRIMARY', name: 'Junior Primary' },
    { id: 'MATHS_SENIOR_PRIMARY', name: 'Senior Primary' },
    { id: 'MATHS_SENIOR_PRIMARY_V2', name: 'Senior Primary V2' },
    { id: 'MATHS_JUNIOR_HIGH', name: 'Junior High' },
  ];

  if (hideSeniorPrimaryV2.value) {
    return options.filter(o => o.id !== 'MATHS_SENIOR_PRIMARY_V2');
  }

  return options;
});

const englishAssessmentOptions = computed(() => {
  const options = [
    { id: 'ENGLISH_SENIOR_PRIMARY', name: 'Senior Primary' },
    { id: 'ENGLISH_JUNIOR_HIGH', name: 'Junior High' },
  ];

  return options;
});

const showMathsAssessmentField = computed(() => {
  return isMathsAvailable.value && (currentMathsAssessment.value || editLearner.value.mathsClass);
});

const showEnglishAssessmentField = computed(() => {
  return isEnglishAvailable.value && (currentEnglishAssessment.value || editLearner.value.englishClass);
});

// Assessment level hierarchy for validation
const assessmentLevelHierarchy: Record<string, number> = {
  "MATHS_JUNIOR_PRIMARY": 0,
  "MATHS_SENIOR_PRIMARY": 1,
  "MATHS_SENIOR_PRIMARY_V2": 1,
  "MATHS_JUNIOR_HIGH": 2,
  "ENGLISH_SENIOR_PRIMARY": 0,
  "ENGLISH_JUNIOR_HIGH": 1
};

// Assessment level validation methods for FormKit
const valid_maths_assessment_change = (node: FormKitNode): boolean => {
  if (!currentMathsAssessment.value || !node.value) return true;

  const currentLevel = assessmentLevelHierarchy[currentMathsAssessment.value.type];
  const newLevel = assessmentLevelHierarchy[node.value as string];

  // Allow change only if it's by one level
  return Math.abs(currentLevel - newLevel) <= 1;
};

const valid_english_assessment_change = (node: FormKitNode): boolean => {
  if (!currentEnglishAssessment.value || !node.value) return true;

  const currentLevel = assessmentLevelHierarchy[currentEnglishAssessment.value.type];
  const newLevel = assessmentLevelHierarchy[node.value as string];

  // Allow change only if it's by one level
  return Math.abs(currentLevel - newLevel) <= 1;
};

// Email validation - allow same email for current student
const email_exists = async (node: FormKitNode): Promise<boolean> => {
  // If email hasn't changed, it's valid
  if (node.value === originalEmail.value) {
    return true;
  }

  try {
    const emailExists = await learnerStore.validateEmail(node.value as string);
    return !emailExists;
  } catch (error) {
    return true;
  }
};

function getAssessmentTypeForGrade(subject: 'MATHS' | 'ENGLISH', grade: number): string {
  if (subject === 'MATHS') {
    if (grade <= 4) return 'MATHS_JUNIOR_PRIMARY';
    if (grade <= 7) return hideSeniorPrimaryV2.value ? 'MATHS_SENIOR_PRIMARY' : 'MATHS_SENIOR_PRIMARY_V2';
    return 'MATHS_JUNIOR_HIGH';
  }
  if (subject === 'ENGLISH') {
    if (grade <= 7) return 'ENGLISH_SENIOR_PRIMARY';
    return 'ENGLISH_JUNIOR_HIGH';
  }
  return '';
}

// Validate assessment level changes
const validateAssessmentLevel = (subject: 'MATHS' | 'ENGLISH') => {
  if (subject === 'MATHS' && currentMathsAssessment.value) {
    const currentLevel = assessmentLevelHierarchy[currentMathsAssessment.value.type];
    const newLevel = assessmentLevelHierarchy[editLearner.value.mathsAssessmentLevel];
    isValidMathsAssessment.value = Math.abs(currentLevel - newLevel) <= 1;
  } else if (subject === 'ENGLISH' && currentEnglishAssessment.value) {
    const currentLevel = assessmentLevelHierarchy[currentEnglishAssessment.value.type];
    const newLevel = assessmentLevelHierarchy[editLearner.value.englishAssessmentLevel];
    isValidEnglishAssessment.value = Math.abs(currentLevel - newLevel) <= 1;
  }
};


const triggerFormSubmit = async () => {
  submitForm('edit-learner-form')
}

const onSubmitEditLearnerForm = async () => {
  // --- NEW VALIDATION LOGIC ---
  const gradeChanged = editLearner.value.grade !== originalValues.value.grade;

  if (gradeChanged) {
    // Check if any subjects are available to be assigned
    const subjectsAreAvailable = isMathsAvailable.value || isEnglishAvailable.value;

    // Check if the user has selected a new class for at least one available subject
    const newClassWasSelected = (isMathsAvailable.value && editLearner.value.mathsClass) || (isEnglishAvailable.value && editLearner.value.englishClass);

    // If the grade changed and subjects are available, a new class must be chosen
    if (subjectsAreAvailable && !newClassWasSelected) {
      showToast({
        text: 'When changing a grade, you must select at least one new class.',
        type: 'error',
        icon: ExclamationTriangleIcon, // Using a more appropriate icon for a warning/error
      });
      return; // Stop the form submission
    }
  }
  // --- END OF NEW LOGIC ---

  try {
    // Validate assessment levels
    if (!isValidMathsAssessment.value || !isValidEnglishAssessment.value) {
      showToast({
        text: 'Assessment level can only be changed by one level at a time',
        type: 'error',
        icon: CheckCircleIcon,
      });
      return;
    }

    // Get current student data
    const currentStudent = learnerStore.getLearnerById(props.studentId);
    if (!currentStudent) {
      throw new Error('Student not found');
    }

    // Build update payload - only include changed fields
    const updatePayload: any = {};

    // Check basic field changes
    if (editLearner.value.password && editLearner.value.password !== originalValues.value.password) {
      updatePayload.password = editLearner.value.password;
    }

    if (editLearner.value.firstName !== originalValues.value.firstName) {
      updatePayload.firstName = editLearner.value.firstName;
    }
    if (editLearner.value.lastName !== originalValues.value.lastName) {
      updatePayload.lastName = editLearner.value.lastName;
    }
    if (editLearner.value.email !== originalValues.value.email) {
      updatePayload.email = editLearner.value.email;
    }
    if (editLearner.value.studentNumber !== originalValues.value.studentNumber) {
      updatePayload.studentNumber = editLearner.value.studentNumber;
    }
    if (editLearner.value.grade !== originalValues.value.grade) {
      updatePayload.grade = editLearner.value.grade;
    }

    if (editLearner.value.repeatingGrade !== originalValues.value.repeatingGrade) {
      updatePayload.repeatingGrade = editLearner.value.repeatingGrade;
    }

    if (editLearner.value.preferredLang !== originalValues.value.preferredLang) {
      updatePayload.preferredLang = editLearner.value.preferredLang;
    }

    if (editLearner.value.learningMode !== originalValues.value.learningMode) {
      updatePayload.learningMode = editLearner.value.learningMode;
    }

    // --- START: New logic for creating assessments ---
    updatePayload.newAssessments = [];

    // Check if a new Maths assessment needs to be created
    if (editLearner.value.mathsClass && !currentMathsAssessment.value) {
      updatePayload.newAssessments.push({
        subject: 'MATHS',
        type: editLearner.value.mathsAssessmentLevel,
      });
    }

    // Check if a new English assessment needs to be created
    if (editLearner.value.englishClass && !currentEnglishAssessment.value) {
      updatePayload.newAssessments.push({
        subject: 'ENGLISH',
        type: editLearner.value.englishAssessmentLevel,
      });
    }

    if (updatePayload.newAssessments.length === 0) {
      delete updatePayload.newAssessments;
    }
    // --- END: New logic for creating assessments ---

    // Build classes array with changes
    const classes = [];
    const currentMathsClass = currentStudent.classes?.find(cls => cls.subject.code === 'MATHS');
    const currentEnglishClass = currentStudent.classes?.find(cls => cls.subject.code === 'ENGLISH');

    // Handle Maths class changes
    if (isMathsAvailable.value) {
      const mathsClassChanged = editLearner.value.mathsClass !== originalValues.value.mathsClass;
      if (mathsClassChanged) {
        classes.push({
          currentClass: currentMathsClass?._id || "",
          newClass: editLearner.value.mathsClass || ""
        });
      }
    }

    // Handle English class changes
    if (isEnglishAvailable.value) {
      const englishClassChanged = editLearner.value.englishClass !== originalValues.value.englishClass;
      if (englishClassChanged) {
        classes.push({
          currentClass: currentEnglishClass?._id || "",
          newClass: editLearner.value.englishClass || ""
        });
      }
    }

    // Only include classes if there are changes
    if (classes.length > 0) {
      updatePayload.classes = classes;
    }

    // Handle assessment upgrades
    const assessmentUpgrades = [];

    if (currentMathsAssessment.value &&
      editLearner.value.mathsAssessmentLevel !== originalValues.value.mathsAssessmentLevel) {
      assessmentUpgrades.push({
        _id: currentMathsAssessment.value._id,
        type: currentMathsAssessment.value.type,
        subject: currentMathsAssessment.value.subject,
        newType: editLearner.value.mathsAssessmentLevel
      });
    }

    if (currentEnglishAssessment.value &&
      editLearner.value.englishAssessmentLevel !== originalValues.value.englishAssessmentLevel) {
      assessmentUpgrades.push({
        _id: currentEnglishAssessment.value._id,
        type: currentEnglishAssessment.value.type,
        subject: currentEnglishAssessment.value.subject,
        newType: editLearner.value.englishAssessmentLevel
      });
    }

    // Only include assessment upgrades if there are changes
    if (assessmentUpgrades.length > 0) {
      updatePayload.assessmentUpgrades = assessmentUpgrades;
    }

    // Check if there are any changes
    if (Object.keys(updatePayload).length === 0) {
      showToast({
        text: 'No changes detected',
        type: 'info',
        icon: CheckCircleIcon,
      });
      emit('closeModal');
      return;
    }

    // console.log("Update Payload: ", updatePayload)

    // Update the learner
    const result = await learnerStore.updateLearner([props.studentId], updatePayload);

    if (result) {
      showToast({
        text: `Successfully updated ${editLearner.value.firstName} ${editLearner.value.lastName}`,
        type: 'success',
        icon: CheckCircleIcon,
      });

      // If the password was part of the update, emit the event with the student's ID
      if (updatePayload.password) {
        emit('password-updated', props.studentId);
      }

      emit('closeModal');
    } else {
      throw new Error('Failed to update student');
    }
  } catch (error) {
    console.error('Failed to update learner:', error);
    showToast({
      text: 'Failed to update student. Please try again.',
      type: 'error',
      icon: CheckCircleIcon,
    });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-edit-user',
            title: 'rl chat bubbles',
            "aria-hidden": "true"
          })
        ])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FormKit, {
        type: "form",
        actions: false,
        modelValue: editLearner.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editLearner).value = $event)),
        id: "edit-learner-form",
        onSubmit: onSubmitEditLearnerForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FormKit, {
              type: "text",
              label: `First Name`,
              id: "firstName",
              name: "firstName",
              "outer-class": "input-thin",
              placeholder: `First Name`
              ,
              validation: "required",
              classes: {
                outer: 'col-span-1',
              }
            }, {
              label: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              label: `Surname`,
              id: "lastName",
              name: "lastName",
              "outer-class": "input-thin",
              placeholder: `Surname`
            ,
              validation: "required",
              suffixIcon: false,
              classes: {
              outer: 'col-span-1',
            }
            }, {
              label: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_FormKit, {
              type: "email",
              name: "email",
              id: "email",
              "outer-class": "input-thin",
              placeholder: `tech@reflectivelearning.co.za`
            ,
              validation: "required|length:0,60|(500)email_exists",
              "validation-rules": { email_exists: email_exists },
              "validation-messages": {
              email_exists: 'Email already exists',
              length: 'Email must be 60 characters or fewer',
            },
              classes: {
              outer: 'col-span-1'
            }
            }, {
              label: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["placeholder", "validation-rules"]),
            _createVNode(_component_FormKit, {
              type: "text",
              name: "password",
              label: "Password",
              "outer-class": "input-thin",
              placeholder: "Enter student password",
              validation: "required|length:6",
              disabled: isPasswordLoading.value,
              classes: {
              outer: 'col-span-1',
            }
            }, {
              label: _withCtx(() => [
                _createElementVNode("label", _hoisted_11, [
                  _createTextVNode(" Password"),
                  _hoisted_12,
                  (isPasswordLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(Loading...)"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            (isClassDataLoaded.value && !schoolIsV2Only.value)
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  type: "choose",
                  size: 'md',
                  showIcon: false,
                  name: "preferredLang",
                  label: "Language",
                  modelValue: editLearner.value.preferredLang,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editLearner.value.preferredLang) = $event)),
                  selectOptions: languageOptions.value,
                  placeholder: 'Select Language',
                  classes: {
              outer: 'col-span-1',
            }
                }, null, 8, ["modelValue", "selectOptions"]))
              : _createCommentVNode("", true),
            (isClassDataLoaded.value && !schoolIsV2Only.value)
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 1,
                  type: "choose",
                  size: 'md',
                  showIcon: false,
                  name: "learningMode",
                  label: "Learning Mode",
                  modelValue: editLearner.value.learningMode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editLearner.value.learningMode) = $event)),
                  selectOptions: learningModeOptions.value,
                  placeholder: 'Select Learning Mode',
                  classes: {
              outer: 'col-span-1',
            }
                }, null, 8, ["modelValue", "selectOptions"]))
              : _createCommentVNode("", true),
            _createVNode(_component_FormKit, {
              type: "text",
              name: "studentNumber",
              label: `Student Number`,
              "outer-class": "input-thin",
              placeholder: "Student Number (Optional)",
              classes: {
              outer: 'col-span-1',
            }
            }),
            _createVNode(_component_FormKit, {
              id: "grade",
              type: "choose",
              size: 'md',
              showIcon: false,
              name: "grade",
              label: "Grade",
              modelValue: editLearner.value.grade,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editLearner.value.grade) = $event)),
              selectOptions: gradeOptions.value,
              placeholder: 'Select Grade',
              validation: "required",
              classes: {
              outer: 'col-span-1',
            }
            }, {
              label: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["modelValue", "selectOptions"]),
            _createElementVNode("div", _hoisted_15, [
              (isMathsAvailable.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 0,
                    type: "choose",
                    size: 'md',
                    showIcon: false,
                    name: "mathsClass",
                    label: mathsClassLabel.value,
                    "label-class": "text-gray-400",
                    modelValue: editLearner.value.mathsClass,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editLearner.value.mathsClass) = $event)),
                    placeholder: mathsClassPlaceholder.value,
                    selectOptions: mathsClassOptionsByGrade.value,
                    classes: {
                outer: 'w-full',
              }
                  }, null, 8, ["label", "modelValue", "placeholder", "selectOptions"]))
                : _createCommentVNode("", true),
              (isEnglishAvailable.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 1,
                    type: "choose",
                    size: 'md',
                    showIcon: false,
                    name: "englishClass",
                    label: englishClassLabel.value,
                    "label-class": "text-gray-400",
                    modelValue: editLearner.value.englishClass,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editLearner.value.englishClass) = $event)),
                    placeholder: englishClassPlaceholder.value,
                    selectOptions: englishClassOptionsByGrade.value,
                    classes: {
                outer: 'w-full',
              }
                  }, null, 8, ["label", "modelValue", "placeholder", "selectOptions"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (showMathsAssessmentField.value)
                  ? (_openBlock(), _createBlock(_component_FormKit, {
                      key: 0,
                      type: "choose",
                      size: 'md',
                      showIcon: false,
                      disabled: disableAssessmentFields,
                      name: "mathsAssessmentLevel",
                      label: "Maths Assessment Level",
                      "label-class": "text-gray-400",
                      "validation-visibility": "live",
                      validation: "required|valid_maths_assessment_change",
                      "validation-rules": { valid_maths_assessment_change: valid_maths_assessment_change },
                      "validation-messages": {
                  valid_maths_assessment_change: 'Maths assessment can only be changed by one level at a time',
                },
                      modelValue: editLearner.value.mathsAssessmentLevel,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editLearner.value.mathsAssessmentLevel) = $event)),
                      placeholder: 'Select Assessment Level',
                      selectOptions: mathsAssessmentOptions.value,
                      classes: {
                  outer: 'w-full',
                }
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("label", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, [
                            _createTextVNode(" Maths Assessment Level "),
                            _withDirectives((_openBlock(), _createElementBlock("i", null, [
                              _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4" })
                            ])), [
                              [
                                _directive_tooltip,
                                'Editing a Student’s Assessment Level typically gives a fresh start, with progress appearing to reset',
                                "top",
                                { tooltip: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-rules", "modelValue", "selectOptions"]))
                  : _createCommentVNode("", true),
                (showEnglishAssessmentField.value && !schoolIsV2Only.value)
                  ? (_openBlock(), _createBlock(_component_FormKit, {
                      key: 1,
                      type: "choose",
                      size: 'md',
                      showIcon: false,
                      disabled: disableAssessmentFields,
                      name: "englishAssessmentLevel",
                      label: "English Assessment Level",
                      "label-class": "text-gray-400",
                      validation: "required|valid_english_assessment_change",
                      "validation-rules": { valid_english_assessment_change: valid_english_assessment_change },
                      "validation-messages": {
                  valid_english_assessment_change: 'English assessment can only be changed by one level at a time',
                },
                      modelValue: editLearner.value.englishAssessmentLevel,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editLearner.value.englishAssessmentLevel) = $event)),
                      placeholder: 'Select Assessment Level',
                      selectOptions: englishAssessmentOptions.value,
                      classes: {
                  outer: 'w-full',
                }
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("label", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _createTextVNode(" English Assessment Level "),
                            _withDirectives((_openBlock(), _createElementBlock("i", null, [
                              _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4" })
                            ])), [
                              [
                                _directive_tooltip,
                                'Editing a Student’s Assessment Level typically gives a fresh start, with progress appearing to reset',
                                "top",
                                { tooltip: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-rules", "modelValue", "selectOptions"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_FormKit, {
              type: "checkbox",
              name: "repeatingGrade",
              label: "Will repeat the current Grade/Year",
              "outer-class": "flex items-center gap-2 text-[#344054]",
              modelValue: editLearner.value.repeatingGrade,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editLearner.value.repeatingGrade) = $event)),
              config: {
              classes: {
                outer: 'mt-4',
                wrapper: 'flex items-center',
                inner: 'flex items-center',
                input: 'form-checkbox h-5 w-5 text-blue-600 bg-gray-100 border-gray-300 rounded-md focus:ring-blue-500 focus:ring-2',
                label: 'ml-3 text-slate-700 text-sm font-medium',
              },
            }
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (showGradeChangeWarning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(ExclamationTriangleIcon), {
                  class: "size-5 text-yellow-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_25
            ])
          ]))
        : _createCommentVNode("", true),
      (assessmentLevelToChange.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_unref(ExclamationTriangleIcon), {
                  class: "size-5 text-yellow-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_29
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('closeModal'))),
          type: "button",
          class: "w-1/2 rounded-md bg-white px-2.5 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        }, " Cancel "),
        _createElementVNode("button", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (triggerFormSubmit())),
          type: "button",
          class: "w-1/2 rounded-md bg-blue-600 hover:bg-blue-500 px-2.5 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        }, [
          (_unref(learnerStore).loader.learner)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                _createTextVNode(" " + _toDisplayString(_unref(learnerStore).loadingMessage), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_33, " Update Student "))
        ])
      ])
    ])
  ]))
}
}

})